import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import { Accordion, Input } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as _ from 'lodash';

import { StyleGuideNav } from 'Common/Constants/';
import * as CommonStateSelectors from 'State/selectors';
import { AccessInfoEnum } from 'Common/Constants/Enumeration/AccessInfoEnum';

import { env, ENV_DEV, HOT_RELOAD } from '../../../env';
import { NavGroup } from './NavGroup';
import {
  VERIFICATION_HEADER,
  VERIFICATION_SPECIAL_SORTING,
  MENUS_GROUP_NAME,
  INVENTORY_GROUP_NAME,
  SERVE_GROUP_NAME,
} from './Constants';

import 'Styles/components/nav.less';

class AppSidebarNavContainer extends React.Component {
  static propTypes = {
    accessInfo: PropTypes.array.isRequired,
    isOnline: PropTypes.bool,
  };
  state = { filter: '', activeGroup: null };

  onFilterChange = (e, { value }) => {
    this.setState({ filter: value });
  };

  shouldFilter = () => {
    return this.state.filter.length >= 3;
  };

  resetFilter = () => {
    this.setState({ filter: '' });
  };

  getGroupData = () => {
    //remove preferences from sidebar
    const { accessInfo, offlineMode } = this.props;

    let data = _.filter(accessInfo, (x) => {
      if (!offlineMode) {
        return x.GroupName.toLowerCase() !== 'preference';
      }

      return (
        x.Id === AccessInfoEnum.PointOfSale.Id &&
        x.GroupName.toLowerCase() ===
          AccessInfoEnum.PointOfSale.GroupName.toLowerCase()
      );
    });

    const accessInfosGroupedByGroupName = _.groupBy(data, 'GroupName');

    Object.keys(accessInfosGroupedByGroupName).forEach((groupName) => {
      const accessInfos = accessInfosGroupedByGroupName[groupName];
      accessInfosGroupedByGroupName[groupName] = this.sortAndRearrange(
        accessInfos
      );
    });

    return accessInfosGroupedByGroupName;
  };

  sortAndRearrange = (data) => {
    // Verification requires special sorting
    let verificationData = data.filter(
      (item) => item.SubGroupName === VERIFICATION_HEADER
    );
    // If the function name is in VERIFICATION_SPECIAL_SORTING then sort by the index, otherwise put the item at the end without changing the sort order
    verificationData = _.sortBy(verificationData, (i) => {
      const index = VERIFICATION_SPECIAL_SORTING.findIndex(
        (x) => x === i.FunctionName
      );
      return index >= 0 ? index : VERIFICATION_SPECIAL_SORTING.length + 1;
    });

    let ordinalBasedAccessInfos = data.filter(
      (item) =>
        item.GroupName === MENUS_GROUP_NAME ||
        item.GroupName === INVENTORY_GROUP_NAME ||
        item.GroupName === SERVE_GROUP_NAME
    );
    ordinalBasedAccessInfos = _.sortBy(
      ordinalBasedAccessInfos,
      (ai) => ai.Ordinal
    );

    return [
      ..._.sortBy(
        data.filter(
          (item) =>
            item.SubGroupName !== VERIFICATION_HEADER &&
            item.GroupName !== MENUS_GROUP_NAME &&
            item.GroupName !== INVENTORY_GROUP_NAME &&
            item.GroupName !== SERVE_GROUP_NAME
        ),
        (x) => x.FunctionName
      ),
      ...verificationData,
      ...ordinalBasedAccessInfos,
    ];
  };

  componentDidMount() {
    this.setActiveFromUrl();
  }

  setActiveFromUrl = () => {
    const productGroups = this.getGroupData();

    _.forEach(productGroups, (accessInfoList, productGroup) => {
      accessInfoList.forEach((accessInfo) => {
        let path = window.location.pathname;
        if (path.lastIndexOf('/') > 0) {
          path = path.substring(0, path.indexOf('/', 1));
        }
        if (path === accessInfo.PathUrlSegment) {
          this.setState({ activeGroup: productGroup });
        }
      });
    });
  };

  render() {
    const { activeGroup } = this.state;
    const productGroups = this.getGroupData();
    let panels = [];

    _.forEach(productGroups, (accessInfoList, productGroup) => {
      if (this.shouldFilter()) {
        accessInfoList = accessInfoList.filter(
          (element) =>
            element.FunctionName.toLowerCase().indexOf(
              this.state.filter.toLowerCase()
            ) !== -1
        );
      }

      if (accessInfoList.length === 0) {
        return;
      }

      const item = {
        title: {
          key: `title-${productGroup}`,
          content: productGroup,
          className: productGroup.toString().toLowerCase(),
          onClick: (e, { active }) => {
            if (!active) {
              this.setState({ activeGroup: productGroup });
            } else {
              this.setState({ activeGroup: null });
            }
          },
        },
        content: {
          content: (
            <NavGroup
              items={accessInfoList}
              resetFilter={this.resetFilter}
              shouldFilter={this.shouldFilter}
            />
          ),
          key: `content-${productGroup}`,
        },
        key: `accordion-${productGroup}`,
        active: this.shouldFilter() || productGroup === activeGroup,
      };

      panels.push(item);
    });

    if (env === ENV_DEV && !this.shouldFilter()) {
      panels.push(StyleGuideNav);
    }
    panels = _.sortBy(panels, (x) => x.title.content);

    return (
      <Fragment>
        <Input
          className={'nav-filter'}
          size={'small'}
          icon={{ name: 'search' }}
          fluid
          onChange={this.onFilterChange}
          value={this.state.filter}
          placeholder="Go to..."
        />
        {panels.length ? (
          <Accordion panels={panels} style={{ flexGrow: 1 }} />
        ) : (
          <label style={{ flexGrow: 1 }}>No Results Found</label>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const SecurityState = state.SecurityState;

  return {
    accessInfo: SecurityState.accessInfo,
    isOnline: CommonStateSelectors.getOnline(state),
    serverUp: CommonStateSelectors.getServerUp(state),
    offlineMode: CommonStateSelectors.getOfflineMode(state),
  };
};

const Nav = withRouter(connect(mapStateToProps, null)(AppSidebarNavContainer));

let AppSidebarNav = Nav;
if (HOT_RELOAD) {
  AppSidebarNav = hot(module)(Nav);
}

export { AppSidebarNav };



// WEBPACK FOOTER //
// ./src/components/app/sidebar/Nav.js